import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-733de4b9"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "p-10 header bg-neutral-0" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "spacer" }, null, -1))
const _hoisted_3 = { class: "font-bold text-4xl w-full pr-auto" }
const _hoisted_4 = { class: "flex" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_base_icon = _resolveComponent("base-icon")!
  const _component_base_button = _resolveComponent("base-button")!
  const _component_on_boarding_card = _resolveComponent("on-boarding-card")!

  return (_openBlock(), _createElementBlock("nav", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", {
      class: "cursor-pointer flex justify-center flex-wrap",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.openBasketOverlay && _ctx.openBasketOverlay(...args)))
    }, [
      _createElementVNode("h1", _hoisted_3, _toDisplayString(_ctx.t('touchtable.header.basket') + ` (${_ctx.basketAmount})`), 1),
      _createVNode(_component_base_icon, {
        icon: "downwardArrows",
        class: "stroke-current fill-current stroke-2"
      })
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_on_boarding_card, {
        showCard: 
          _ctx.onBoardingState.status == 'started' &&
          _ctx.onBoardingState.currentStepName == 'backToOverviewPage'
            ? true
            : false
        ,
        cardTitle: _ctx.t('touchtable.onBoarding.backToOverview.title'),
        cardDescription: _ctx.t('touchtable.onBoarding.backToOverview.description'),
        nextButtonText: "touchtable.onBoarding.buttons.end",
        placement: "bottom-end"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_base_button, {
            class: "shadow mr-8 text-xl",
            "custom-style": "touchtable-green-round",
            "icon-shown": false,
            text: _ctx.t('touchtable.header.buttons.overview'),
            onClick: _ctx.goToStoriesPage
          }, null, 8, ["text", "onClick"])
        ]),
        _: 1
      }, 8, ["showCard", "cardTitle", "cardDescription"]),
      _createVNode(_component_base_button, {
        class: "shadow text-xl",
        "custom-style": "touchtable-white-round",
        "custom-icon": "door",
        "icon-shown": true,
        text: _ctx.t('touchtable.header.buttons.shutdown'),
        onClick: _ctx.openShutdownModal
      }, null, 8, ["text", "onClick"])
    ])
  ]))
}